import { ACCIDENTAL_HOVER_DEBOUNCE_TIME } from "app/pages/sales-intelligence/constants/timeouts";
import useControlledDelayedAction from "app/pages/sales-intelligence/hooks/useControlledDelayedAction";
import type { ComponentType, MouseEvent, MouseEventHandler } from "react";

type HocProps = {
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
};

const withDelayedHoverEvent = <P extends HocProps>(
    Component: ComponentType<P>,
    delay: number = ACCIDENTAL_HOVER_DEBOUNCE_TIME,
) => {
    return function WrappedWithDelayedHoverEvent(props: P) {
        const { delayedAction: onDelayedMouseEnter, cancelDelayedAction: onDelayedMouseLeave } =
            useControlledDelayedAction({
                delay,
                action: handleMouseEnter,
            });

        function handleMouseEnter(event: MouseEvent): void {
            props.onMouseEnter?.(event);
        }

        function handleMouseLeave(event: MouseEvent): void {
            onDelayedMouseLeave();
            props.onMouseLeave?.(event);
        }

        return (
            <Component
                {...props}
                onMouseEnter={onDelayedMouseEnter}
                onMouseLeave={handleMouseLeave}
            />
        );
    };
};

export default withDelayedHoverEvent;
